import styled, { css } from 'styled-components';

import { mediaQueries } from 'theme/mediaQueries';
import { color } from 'theme/selectors';

export const ReasonItem = styled.button<{ isSelected: boolean }>`
    background: ${color('surface-default')};
    padding: 16px 20px;
    display: flex;
    align-items: center;
    width: 100%;
    border-radius: 12px !important;
    text-align: left;
    margin-bottom: 12px;
    cursor: pointer;
    height: 80px;
    overflow: hidden;
    transition: 0.2s ease;

    > * {
        transition: 0.2s ease;
    }

    ${({ isSelected }) =>
        isSelected &&
        css`
            background: ${color('primary-active')};

            > * {
                color: ${color('on-primary')};
            }
        `}
    ${mediaQueries.laptop} {
        &:hover {
            ${({ isSelected }) => css`
                background: ${color(isSelected ? 'primary-active' : 'primary-default')};
            `}
            > * {
                color: ${color('on-primary')};
            }
        }
    }
`;

export const ReasonItemDot = styled.div<{ isSelected: boolean }>`
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background-color: ${color('surface-default')};
    border: 2px solid ${color('border-default')};
    margin-left: auto;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    ${ReasonItem}:hover & {
        background-color: ${color('primary-active')};
        border-color: ${color('on-primary')};
    }
    ${({ isSelected }) =>
        isSelected &&
        css`
            background-color: ${color('primary-active')};
            border-color: ${color('on-primary')};
            &:before {
                content: '';
                display: block;
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background-color: ${color('on-primary')};
            }}
        `}
`;

export const ReasonItemSubmitBtn = styled.button<{ isSelected: boolean }>`
    position: relative;
    cursor: pointer;
    background-color: ${color('surface-default')};

    width: 100%;
`;
